import { useEffect } from 'react';

import { useStore } from '@/store/useStore';
import { useReloadBalance } from '@/unified-modules/wallet/helpers/useReloadBalance';

export const useReloadBalanceOnVisible = () => {
  const reloadBalance = useReloadBalance();
  const hasActiveSession = useStore(
    (s) => s.userSessionContext.hasActiveSession,
  );

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document?.visibilityState !== 'visible' || !hasActiveSession) return;

      void reloadBalance();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [reloadBalance, hasActiveSession]);
};

export default useReloadBalanceOnVisible;
